/* REACT */
import React, { useMemo, useState, useEffect } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'
import moment from 'moment'
import 'moment/locale/nl'

/* COMPONENTS */
import Rating from '../../../ui/rating/rating'

/* STORE */
import { setIsPopoverChatOpen } from '../../../../store/general/actions'

/* STYLES */
import {
  ItemImageWrapper,
  ItemImage,
  Title,
  TitleWrapper,
  GridItemWrapper,
  TripTypeWrapper,
  TripTypeSeparator,
  TripTypeOnCard,
  TripAvailibilty,
  TripAvailibiltyIcon,
  TripAvailibiltyText,
  TripDetailsWrapper,
  TripSecondaryDetailsWrapper,
  TripSecondaryDetailsItemWrapper,
  TripPrice,
  GridItemDetailsWrapper,
  Location,
} from './style'

/* UTILS/CONSTANTS*/
import { CLOUDFRONT_BASE_URL } from '../../../../utils/constants'
import { Analytics, getTranslations } from '../../../../utils'
import { logAction } from '../../../../utils/actionLogger'

/*ASSETS*/
const NoImage = `${CLOUDFRONT_BASE_URL}/assets/images/NoImage.png`
const PinImage = `${CLOUDFRONT_BASE_URL}/assets/icons/Pin.svg`

const TripItem = ({
  index,
  isLessThanLaptop,
  item,
  router,
  language,
  setIsPopoverChatOpen,
  key,
  openPopoverChatOnClickthrough,
  showRelevancyInfo,
  randomMatch,
  itemsPerRow,
  organizationDetails,
  slug,
  token,
}) => {
  // SET MOMENT LOCALE TO CURRENT LANGUAGE
  moment.locale(language)

  const {
    name,
    images,
    price,
    destinations,
    label_image,
    label_card,
    keywords,
    rating_value,
    rating_total_value,
    description,
    label_bottom,
  } = item

  const [tripPrice, setTripPrice] = useState(price)
  const [isHovered, setIsHovered] = useState(false)

  const itemImage = images?.length ? images[0]?.url : NoImage

  const mouseDownCoords = e => {
    window.checkForDrag = e.clientX
  }

  const setWidthOfNameDiv = () => {
    // IF THERE IS LABEL CARD THEN ADJUST WIDTH OF NAME DIV
    const labelCardDiv = document.getElementById(`trip-label-card-${index}`)
    if (!labelCardDiv) {
      return
    }

    const mainDiv = document.getElementById(
      `grid-item-details-wrapper-${index}`
    )
    const nameDiv = document.getElementById(`trip-title-wrapper-${index}`)

    if (nameDiv && mainDiv) {
      // ADD 20PX FOR THE PADDING
      nameDiv.style.width = `${
        mainDiv.offsetWidth - labelCardDiv.offsetWidth - 20
      }px`
    }
  }

  useEffect(() => {
    setWidthOfNameDiv()
  }, [key, index])

  useEffect(() => {
    // SET TRIP PRICE
    if (item?.trip_info?.length) {
      for (let info of item.trip_info) {
        if (info?.selling_price) {
          // SET PRICE IF NOT SET
          setTripPrice(info.selling_price)

          break
        }
      }
    }
  }, [key])

  const destinationsText = useMemo(() => {
    if (destinations?.length) {
      let text = ''
      let index = 0
      for (let destination of destinations) {
        if (index) {
          text += `, `
        }
        text += `${destination}`
        index += 1
      }
      return text
    }
    return ''
  }, [destinations])

  useEffect(() => {
    const testDiv = document.getElementById(`grid-item-wrapper-${index}`)

    const handleMouseOver = () => {
      // Add your hover logic here
      setIsHovered(true)
    }

    const handleMouseOut = () => {
      // Add your logic for when the hover ends
      setIsHovered(false)
    }

    if (testDiv) {
      testDiv.addEventListener('mouseover', handleMouseOver)
      testDiv.addEventListener('mouseout', handleMouseOut)
    }

    // Cleanup on component unmount
    return () => {
      if (testDiv) {
        testDiv.removeEventListener('mouseover', handleMouseOver)
        testDiv.removeEventListener('mouseout', handleMouseOut)
      }
    }
  }, []) // Empty dependency array ensures this runs once on mount

  const getUrlWithSlugAndToken = url => {
    if (slug && token) {
      // ADD SLUG AND TOKEN TO URL QUERY PARAMS
      // THIS HELPS TO CONTINUE CHATS IF USER VISITS OTHER BRANDS WEBSITES
      const urlObj = new URL(url)
      urlObj.searchParams.set('slug', slug)
      urlObj.searchParams.set('token', token)
      return urlObj.toString()
    }
    return url
  }

  if (!organizationDetails?.slug) {
    return null
  }

  return (
    <GridItemWrapper
      target={
        organizationDetails?.openNewTabOnClickthroughGrid ? '_blank' : '_self'
      }
      id={`grid-item-wrapper-${index}`}
      href={getUrlWithSlugAndToken(item.url)}
      onClick={() => {
        Analytics.getInstance().sendEvent('maya_click_grid_item', {
          item_entity: 'trips',
          item_title: name,
          item_subtitle: tripPrice,
          item_type: label_image,
          item_destination: destinations[0],
          item_url: item.url,
        })
        logAction({
          name: 'url_click_grid',
          url: getUrlWithSlugAndToken(item.url),
          linkLabel: name,
        })
        if (openPopoverChatOnClickthrough) {
          setIsPopoverChatOpen(true)
        }
      }}
      itemsPerRow={itemsPerRow}
    >
      <GridItemDetailsWrapper id={`grid-item-details-wrapper-${index}`}>
        <ItemImageWrapper
          onMouseDown={e => mouseDownCoords(e)}
          isHovered={isHovered}
        >
          <ItemImage index={index} backgroundImage={itemImage}></ItemImage>
        </ItemImageWrapper>
        <TripDetailsWrapper>
          {name || tripPrice ? (
            <TripSecondaryDetailsWrapper>
              {label_card || label_image ? (
                <TripTypeWrapper>
                  <TripTypeOnCard id={`trip-label-card-${index}`}>
                    {label_card}
                  </TripTypeOnCard>
                  <TripTypeSeparator>|</TripTypeSeparator>
                  <TripTypeOnCard id={`trip-label-card-${index}`}>
                    {label_image}
                  </TripTypeOnCard>
                </TripTypeWrapper>
              ) : null}
              {name || description ? (
                <TitleWrapper id={`trip-title-wrapper-${index}`}>
                  {name ? <Location>{name}</Location> : null}
                  {description ? <Title>{description}</Title> : null}
                </TitleWrapper>
              ) : null}

              {tripPrice || label_bottom ? (
                <TripSecondaryDetailsItemWrapper>
                  {' '}
                  {label_bottom ? (
                    <TripAvailibilty>
                      <TripAvailibiltyText>{label_bottom}</TripAvailibiltyText>
                      <TripAvailibiltyIcon
                        class='icon icon--arrow'
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 16 17'
                        fill='none'
                        aria-hidden='true'
                        isHovered={isHovered}
                      >
                        <path
                          d='M3.33325 8.5H12.6666'
                          stroke='currentColor'
                          stroke-width='2'
                          stroke-linecap='round'
                          stroke-linejoin='round'
                        ></path>
                        <path
                          d='M8 3.83337L12.6667 8.50004L8 13.1667'
                          stroke='currentColor'
                          stroke-width='2'
                          stroke-linecap='round'
                          stroke-linejoin='round'
                        ></path>
                      </TripAvailibiltyIcon>
                    </TripAvailibilty>
                  ) : null}
                  {tripPrice ? <TripPrice>{`${tripPrice}`}</TripPrice> : null}
                </TripSecondaryDetailsItemWrapper>
              ) : null}

              {rating_value && rating_total_value ? (
                <Rating
                  title={getTranslations('reviews')}
                  value={rating_value}
                  total={rating_total_value}
                />
              ) : null}
            </TripSecondaryDetailsWrapper>
          ) : null}
        </TripDetailsWrapper>
      </GridItemDetailsWrapper>
    </GridItemWrapper>
  )
}

const mapStateToProps = state => ({
  openPopoverChatOnClickthrough: state?.general?.openPopoverChatOnClickthrough,
  organizationDetails: state?.maya?.organizationDetails,
  slug: state?.maya?.slug,
  token: state?.maya?.token,
})

const mapDispatchToProps = dispatch => ({
  setIsPopoverChatOpen: isOpen => dispatch(setIsPopoverChatOpen(isOpen)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TripItem)
